import React, { useState, useEffect, useCallback } from 'react';
import BackOfficeLayout from '../../components/backoffice/BackOfficeLayout';
import { useAuth } from '../../context/AuthContext';
import { useEnvironment } from '../../context/EnvironmentContext';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { CheckCircle, RefreshCw } from 'lucide-react';

export default function BackOfficeKycApproved() {
  const { api } = useAuth();
  const { isLive } = useEnvironment();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get('/backoffice/merchants?kyc_status=approved&per_page=100');
      setData(res.data?.data || []);
    } catch { setData([]); } finally { setLoading(false); }
  }, [api]);

  useEffect(() => { fetchData(); }, [fetchData, isLive]);

  return (
    <BackOfficeLayout>
      <div className="space-y-6">
        <div className="flex items-center justify-between pb-4">
          <div>
            <h1 className="text-2xl font-bold text-[#073B2E] flex items-center gap-2"><CheckCircle className="w-7 h-7 text-[#0B6445]" />Approved</h1>
            <p className="text-[#0E1B16]/70 mt-2">Merchants with approved KYC / KYB.</p>
          </div>
          <Button variant="outline" size="sm" onClick={fetchData} className="border-[#1C472B] text-[#1C472B] hover:bg-[#E6F7F3] hover:text-[#073B2E]"><RefreshCw className="w-4 h-4 mr-1" />Refresh</Button>
        </div>
        <Card className="border-[#DCE4E0] shadow-sm">
          <CardContent className="pt-6">
            {loading ? (
              <div className="flex justify-center py-12"><div className="spinner w-8 h-8" /></div>
            ) : data.length === 0 ? (
              <p className="text-center py-12 text-[#0E1B16]/60">No approved merchants.</p>
            ) : (
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead><tr className="border-b border-[#DCE4E0]">
                    <th className="text-left py-3 px-2 font-semibold text-[#073B2E]">Name</th>
                    <th className="text-left py-3 px-2 font-semibold text-[#073B2E]">Email</th>
                    <th className="text-left py-3 px-2 font-semibold text-[#073B2E]">Status</th>
                    <th className="text-left py-3 px-2 font-semibold text-[#073B2E]">Created</th>
                  </tr></thead>
                  <tbody>
                    {data.map((row) => (
                      <tr key={row.id} className="border-b border-[#DCE4E0]/80 hover:bg-[#F8FAFC]">
                        <td className="py-3 px-2 font-medium">{row.name || '—'}</td>
                        <td className="py-3 px-2">{row.email}</td>
                        <td className="py-3 px-2"><Badge variant="outline" className="bg-green-50 text-green-700 border-green-200">Approved</Badge></td>
                        <td className="py-3 px-2 text-slate-500">{row.created_at ? new Date(row.created_at).toLocaleDateString() : '—'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </BackOfficeLayout>
  );
}
